import { ACTOR_TAGS } from "@/presentation/helpers/actorTags.js";
import { actionCardComposition } from "./actionCardComposition.js";
import { actionCardVisual } from "@/presentation/prefabs/actor/actionCard/actionCardVisual.js";
import { actionCardInteractions } from "./actionCardInteractions.js";
import { scaleFactor } from "@/presentation/prefabs/actor/actionCard/actionCardUtils.js";

export async function createActionCard(k, cardDef, indexInHand, position) {
    const restingZ = 50 + indexInHand; // Card on the right have a higher zindex thant on the left
    const spawningZ = 200 + indexInHand;

    const actionCard = k.add([
        k.sprite("actionCard"),
        k.pos(position),
        k.anchor("center"),
        k.area(),
        k.z(spawningZ),
        k.scale(scaleFactor.base),
        // Behavior constructor
        actionCardComposition(k, {
            cardData: cardDef,
            handIndex: indexInHand
        }),
        ACTOR_TAGS.ACTION_CARD,
    ]);

    actionCardVisual(k, {
        parent: actionCard,
        cardDef
    });

    actionCardInteractions(k, actionCard);

    await actionCard.spawn(k, position, restingZ);

    return actionCard;
}